module.exports = __webpack_public_path__ + "d5768d435c3760f6edce197d7d962db8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/student-girl.png
// module id = 1166
// module chunks = 0